import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Button from 'components/common/Button/Button'
import Mixin from 'components/common/Mixin'
import Icon from 'components/common/Icon/Icon'
import Popover from 'components/common/Popover'
import {
  PopoverInnerContent,
  PopoverLink,
  CustomPopoverLink,
  CustomPopoverIneerContent
} from 'components/MyGarage2.0/components/SharedStyles'

const OptionsDropdown = ({
  isOpen,
  toggleHideShowDropdown,
  deleteVehicle,
  openVehicleDeleteModal,
  openVehicleEditModal,
  isTrailer,
  isGenericTrailer
}) =>
  <>
    <CustomPopover
      tooltipLeft
      asset="ellipsis-grey"
      alternative="ellipsis-grey"
      smallIcon={ isOpen }
      components={{
        PopoverInnerContent,
        PopoverLink
      }}
      onToggle={ toggleHideShowDropdown }>
      <TrayContent isTrailer={ isTrailer } isGenericTrailer={ isGenericTrailer } >
        { (!isTrailer && !isGenericTrailer) && <TrayButton
          full >
          <Icon asset="edit-black" width="16px" height="18px" alt="edit-vehicle" />
          <ButtonTitle onClick={ openVehicleEditModal }>EDIT</ButtonTitle>
        </TrayButton> }
        <TrayButton
          full >
          <Icon asset="delete-black" width="18px" height="20px" alt="delete-vehicle" />
          { deleteVehicle ?
            <ButtonTitle onClick={ openVehicleDeleteModal }>DELETE</ButtonTitle> :
            <Popover
              title="DELETE"
              components={{ PopoverLink: CustomPopoverLink, PopoverInnerContent: CustomPopoverIneerContent }}
              innerProps={{
                popoverInnerContentProps: {
                  active: !deleteVehicle,
                  popoverPosition: { top: 20, right: -120, tickRight: 75 }
                },
                popoverIconProps: { condition: !deleteVehicle }
              }}
              info="You can not delete this vehicle because it has an upcoming appointment." />
          }
        </TrayButton>
      </TrayContent>
    </CustomPopover>
  </>

OptionsDropdown.propTypes = {
  deleteVehicle: PropTypes.bool,
  isGenericTrailer: PropTypes.bool,
  isOpen: PropTypes.bool,
  isTrailer: PropTypes.bool,
  openVehicleDeleteModal: PropTypes.func,
  openVehicleEditModal: PropTypes.func,
  toggleHideShowDropdown: PropTypes.func
}

export default OptionsDropdown

const CustomPopover = styled(Popover)`
  padding: 0;
  width: 30px;
  height: 30px;
  transform: none;

  & [data-tooltip] {
    margin: 0;
  }
`

const TrayContent = styled.div`
  margin: 0;
  font-size: 12px;
  line-height: 18px;

  && button {
    margin: 0;
  }

  button:first-child {
    border-bottom: ${props => (props.isTrailer || props.isGenericTrailer) ? 'none' : `1px solid ${Theme.colors.light_grey}`};
  }
`

const TrayButton = styled(Button)`
  display: flex;
  align-items: center;
  background-color: ${Theme.colors.white};
  border: none;
  padding: 16px 8px;
  transform: none;
  cursor: pointer;

  :hover {
    background: ${Theme.colors.white};
    color: ${Theme.colors.black_new};
    border: none;
  }

  :disabled {
    background-color: ${Theme.colors.white};
    opacity: 0.4;
  }
`

const ButtonTitle = styled.h4`
  ${Mixin.font.GothamMedium(14, 500, 16)}
  margin: 0 0 0 15px;
  color: ${Theme.colors.black_new};
`
